module.exports = __webpack_public_path__ + "img/la.1de9d17c.svg";